var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97313 2.37448C7.43952 1.5995 8.56308 1.5995 9.02947 2.37448L10.153 4.2414C10.3206 4.51981 10.5939 4.71838 10.9104 4.79169L13.0331 5.28332C13.9143 5.4874 14.2615 6.55597 13.6686 7.23902L12.2402 8.88446C12.0272 9.12985 11.9228 9.45113 11.9509 9.77486L12.1393 11.9456C12.2175 12.8467 11.3086 13.5071 10.4757 13.1543L8.46941 12.3043C8.17021 12.1776 7.8324 12.1776 7.5332 12.3043L5.5269 13.1543C4.69405 13.5071 3.78508 12.8467 3.86328 11.9456L4.05167 9.77486C4.07977 9.45113 3.97538 9.12985 3.76237 8.88447L2.33401 7.23902C1.74108 6.55597 2.08828 5.4874 2.96946 5.28332L5.09219 4.79169C5.40875 4.71838 5.68205 4.51981 5.8496 4.2414L6.97313 2.37448Z",
    fill: "#924D27",
    stroke: "#924D27",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.41b673dbb56a5b3899e9ed4089d92e9c.svg";
export { ForwardRef as ReactComponent };